<a class="noPopup" href="mailto:{{ value }}">{{ value }}</a>
